/**
 * Shared job-id selection logic for the dense config tables (Break Rules, Overtime,
 * Hours Rate). These tables store a per-row `jobIds` with three canonical states:
 *   undefined = none selected (toggled off)   ·   [] = "all jobs"   ·   subset = specific ids.
 *
 * Both helpers take only `{ id }` so they stay decoupled from the full `Job` model.
 */

/** Expand the stored `jobIds` into the concrete ids a multi-select cell should show as selected. */
export const selectedJobIdsForDisplay = (jobIds: string[] | null | undefined, departmentJobs: { id: string }[]): string[] => {
	if (jobIds == null) return [];
	return jobIds.length === 0 ? departmentJobs.map((j) => j.id) : jobIds;
};

/** Collapse a raw multi-select change back to the canonical stored form (undefined | [] | subset). */
export const normalizeSelectedJobIds = (selectedValues: string[], departmentJobs: { id: string }[]): string[] | undefined => {
	const validIds = new Set(departmentJobs.map((j) => j.id));
	const ids = selectedValues.filter((v) => validIds.has(v));
	if (ids.length === 0) return undefined;
	return ids.length === departmentJobs.length ? [] : ids;
};
